class Company {
  constructor({
    id = '',
    identifier = '',
    name = '',
    tradeName = '',
    email = '',
    phone = '',
  } = {}) {
    this.id = id;
    this.identifier = identifier;
    this.name = name;
    this.tradeName = tradeName;
    this.email = email;
    this.phone = phone;
  }

  setData(data) {
    this.id = data.id;
    this.identifier = data.identifier;
    this.name = data.name;
    this.tradeName = data.tradeName;
    this.email = data.email;
    this.phone = data.phone;
    this.organizationId = data.organizationId;
  }

  toUpdate() {
    return {
      identifier: this.identifier,
      name: this.name,
      tradeName: this.tradeName,
      email: this.email,
      phone: this.phone,
    };
  }
}

export default Company;
